import { render, staticRenderFns } from "./StaffTab.vue?vue&type=template&id=157a95d4&scoped=true&"
import script from "./StaffTab.vue?vue&type=script&lang=js&"
export * from "./StaffTab.vue?vue&type=script&lang=js&"
import style0 from "./StaffTab.vue?vue&type=style&index=0&id=157a95d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a95d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157a95d4')) {
      api.createRecord('157a95d4', component.options)
    } else {
      api.reload('157a95d4', component.options)
    }
    module.hot.accept("./StaffTab.vue?vue&type=template&id=157a95d4&scoped=true&", function () {
      api.rerender('157a95d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/Tabs/StaffTab.vue"
export default component.exports